// Search shop navbar functionality.
(function () {
  const kit = window.searchKit;
  const {
    toggle: searchToggle,
    input: searchInput,
    results: searchResults,
  } = kit;
  let selectedSidebarKey = "proSport";
  // Get collections data from shopify store.
  let collectionData = [];
  try {
    collectionData = JSON.parse(
      document.getElementById("shop-collections-data").textContent,
    );
  } catch (error) {
    console.error("Error when calling data from API:", error);
  }
  //  console.log("collectionData", collectionData);
  let productsData = [];
  try {
    productsData = JSON.parse(
      document.getElementById("shop-collections-products-data").textContent,
    );
  } catch (error) {
    console.error("Error when calling data from API:", error);
  }

  // Toggle search input visibility
  searchToggle.addEventListener("click", function (e) {
    searchInput.classList.toggle("active");
    if (searchInput.classList.contains("active")) {
      e.stopPropagation();
      searchInput.focus();
      const results = searchMenu(collectionData, "");
      displayResults(results);
      searchResults.classList.add("active");
    } else {
      searchInput.value = ""; // clean input  value when closed
      searchResults.classList.remove("active");
    }
  });

  // Search functionality
  searchInput.addEventListener("input", function (e) {
    const query = e.target.value.toLowerCase().trim();

    if (query.length < 2) {
      selectedSidebarKey = "proSport"; // default sidebar value
      displayResults(collectionData); // default data
      return;
    }

    const results = searchMenu(productsData, query);

    if (results.length > 0) {
      selectedSidebarKey = "writtenSearch";
      displayResults(results);
      searchResults.classList.add("active");
    } else {
      selectedSidebarKey = "NotFound";
      displayResults([]);
      searchResults.classList.add("active");
    }
  });

  searchInput.addEventListener("keypress", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const query = searchInput.value.trim();

      if (query.length > 0) {
        window.location.href = `/search?q=${encodeURIComponent(query)}`;
      }
    }
  });

  // Close results when clicking outside
  document.addEventListener("click", function (e) {
    const isClickInside = e.target.closest(".search-container");

    if (!isClickInside) {
      searchInput.value = "";
      searchInput.classList.remove("active");
      searchResults.classList.remove("active");
    }
  });

  // Search through collections
  function searchMenu(data, query) {
    return data.filter((item) => item.title.toLowerCase().includes(query));
  }

  const sportsSvgColumnsIcons = {
    NFL: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="football-ball" class="svg-inline--qicon qicon-football-ball qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"></path></svg>`,
      title: "Football",
      isTeamTag: true,
      url: "nfl",
    },
    NBA: {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" width="24" height="24" fill="currentColor"><path d="M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"/></svg>`,
      title: "Basketball",
      isTeamTag: true,
      url: "nba",
    },
    MLB: {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" width="24" height="24" fill="currentColor">
        <path d="M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"/>
        </svg>`,
      title: "Baseball",
      isTeamTag: true,
      url: "mlb",
    },
    NHL: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="hockey-puck" class="svg-inline--qicon qicon-hockey-puck qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"></path></svg>`,
      title: "Hockey",
      isTeamTag: true,
      url: "nhl",
    },
    "Sports - Golf": {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="golf-ball" class="svg-inline--qicon qicon-golf-ball qicon-w-13" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 416 512"><path fill="currentColor" d="M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"></path></svg>`,
      title: "golf",
      isTeamTag: false,
      url: "golf",
    },
    "Sports - Boxing": {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="hand-rock" class="svg-inline--qicon qicon-hand-rock qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M512 128.79c0-26.322-20.861-48.344-47.18-48.783C437.935 79.558 416 101.217 416 128h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C333.935 47.558 312 69.217 312 96v32h-8V80.79c0-26.322-20.861-48.344-47.18-48.783C229.935 31.558 208 53.217 208 80v48h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C125.935 47.558 104 69.217 104 96v136l-8-7.111V176.79c0-26.322-20.861-48.344-47.18-48.783C21.935 127.558 0 149.217 0 176v66.445a95.998 95.998 0 0 0 32.221 71.751l111.668 99.261A47.999 47.999 0 0 1 160 449.333V456c0 13.255 10.745 24 24 24h240c13.255 0 24-10.745 24-24v-2.921a96.01 96.01 0 0 1 7.523-37.254l48.954-116.265A96.002 96.002 0 0 0 512 262.306V128.79z"></path></svg>`,
      title: "Boxing",
      isTeamTag: false,
      url: "boxing",
    },
    "Sports - Horse Racing": {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="flag-checkered" class="svg-inline--qicon qicon-flag-checkered qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M466.515 66.928C487.731 57.074 512 72.551 512 95.944v243.1c0 10.526-5.161 20.407-13.843 26.358-35.837 24.564-74.335 40.858-122.505 40.858-67.373 0-111.63-34.783-165.217-34.783-50.853 0-86.124 10.058-114.435 22.122V488c0 13.255-10.745 24-24 24H56c-13.255 0-24-10.745-24-24V101.945C17.497 91.825 8 75.026 8 56 8 24.296 34.345-1.254 66.338.048c28.468 1.158 51.779 23.968 53.551 52.404.52 8.342-.81 16.31-3.586 23.562C137.039 68.384 159.393 64 184.348 64c67.373 0 111.63 34.783 165.217 34.783 40.496 0 82.612-15.906 116.95-31.855zM96 134.63v70.49c29-10.67 51.18-17.83 73.6-20.91v-71.57c-23.5 2.17-40.44 9.79-73.6 21.99zm220.8 9.19c-26.417-4.672-49.886-13.979-73.6-21.34v67.42c24.175 6.706 47.566 16.444 73.6 22.31v-68.39zm-147.2 40.39v70.04c32.796-2.978 53.91-.635 73.6 3.8V189.9c-25.247-7.035-46.581-9.423-73.6-5.69zm73.6 142.23c26.338 4.652 49.732 13.927 73.6 21.34v-67.41c-24.277-6.746-47.54-16.45-73.6-22.32v68.39zM96 342.1c23.62-8.39 47.79-13.84 73.6-16.56v-71.29c-26.11 2.35-47.36 8.04-73.6 17.36v70.49zm368-221.6c-21.3 8.85-46.59 17.64-73.6 22.47v71.91c27.31-4.36 50.03-14.1 73.6-23.89V120.5zm0 209.96v-70.49c-22.19 14.2-48.78 22.61-73.6 26.02v71.58c25.07-2.38 48.49-11.04 73.6-27.11zM316.8 212.21v68.16c25.664 7.134 46.616 9.342 73.6 5.62v-71.11c-25.999 4.187-49.943 2.676-73.6-2.67z"></path></svg>`,
      title: "Horse Racing",
      isTeamTag: false,
      url: "all",
    },
    "Sports - Tennis": {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="table-tennis" class="svg-inline--qicon qicon-table-tennis qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"></path></svg>`,
      title: "Tennis",
      isTeamTag: false,
      url: "tennis",
    },
    "Sports - Soccer": {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="futbol" class="svg-inline--qicon qicon-futbol qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"></path></svg>`,
      title: "Soccer",
      isTeamTag: false,
      url: "soccer",
    },
    "Auto Racing": {
      icon: `<span class="tmenu_item_icon"><svg aria-hidden="true" data-prefix="fas" data-icon="tachometer-alt" class="svg-inline--qicon qicon-tachometer-alt qicon-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"></path></svg></span>`,
      title: "Auto Racing",
      isTeamTag: false,
      url: "auto-racing",
    },
    MMA: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="hand-rock" class="svg-inline--qicon qicon-hand-rock qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M512 128.79c0-26.322-20.861-48.344-47.18-48.783C437.935 79.558 416 101.217 416 128h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C333.935 47.558 312 69.217 312 96v32h-8V80.79c0-26.322-20.861-48.344-47.18-48.783C229.935 31.558 208 53.217 208 80v48h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C125.935 47.558 104 69.217 104 96v136l-8-7.111V176.79c0-26.322-20.861-48.344-47.18-48.783C21.935 127.558 0 149.217 0 176v66.445a95.998 95.998 0 0 0 32.221 71.751l111.668 99.261A47.999 47.999 0 0 1 160 449.333V456c0 13.255 10.745 24 24 24h240c13.255 0 24-10.745 24-24v-2.921a96.01 96.01 0 0 1 7.523-37.254l48.954-116.265A96.002 96.002 0 0 0 512 262.306V128.79z"></path></svg>`,
      title: "MMA",
      isTeamTag: false,
      url: "mma",
    },
  };

  const sideBarNavInfo = {
    proSport: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="football-ball" class="svg-inline--qicon qicon-football-ball qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512"><path fill="currentColor" d="M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"></path></svg>`,
      title: "Pro Sports",
      isTeam: true,
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    NCAA: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="school" class="svg-inline--qicon qicon-school qicon-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"></path></svg>`,
      title: "College Teams",
      isTeam: true,
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Mysterybox: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="box" class="svg-inline--qicon qicon-box qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
          <path fill="currentColor" d="M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.7 5.3-2.5 10.9-2.5 16.5V432c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V201.1c0-5.6-.8-11.2-2.5-16.5zM256 432L64 336v-96l192 96 192-96v96l-192 96zm0-224L128 96h256L256 208z"/>
        </svg>`,
      title: "Mystery Box Collection",
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Entertainment: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="tv" class="svg-inline--qicon qicon-tv qicon-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="currentColor" d="M592 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h245.1v32h-160c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160v-32H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h512v288z"></path></svg>`,
      title: "Entertainment",
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Patriotic: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="flag" class="svg-inline--qicon qicon-flag qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"></path></svg>`,
      title: "Patriotic",
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Outdoors: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="tree" class="svg-inline--qicon qicon-tree qicon-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"></path></svg>`,
      title: "Outdoors",
      hasBorder: true,
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Autographs: {
      icon: `<svg aria-hidden="true" data-prefix="fas" data-icon="pencil-alt" class="svg-inline--qicon qicon-pencil-alt qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"></path></svg>`,
      title: "Authentic Autographs",
      hasBorder: true,
    },
    ByStyle: {
      icon: ``,
      title: "By Style",
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    ByType: {
      icon: ``,
      title: "By Type",
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
    Special: {
      icon: ``,
      title: "Special",
      arrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"></path></svg>`,
    },
  };

  function renderComponentByKey(types, key) {
    //    console.log("types", types, 'key', key);
    const proSport = [];
    switch (key) {
      case "proSport":
        const mainTeamFilter = ["NFL", "NBA", "MLB", "NHL"];
        const excludeTitlesProSport = [
          "NFL",
          "NBA",
          "NHL",
          "Golf",
          "Boxing",
          "Horse Racing",
          "Tennis",
          "Soccer",
        ];
        let html = `<div class="pro-teams-grid">`;

        Object.keys(types).forEach((type) => {
          if (types[type].length >= 0 && mainTeamFilter.includes(type)) {
            html += `<div class="search-column">
            <a href="/collections/${sportsSvgColumnsIcons[type]?.title}" class="search-result-columns-category">
              ${sportsSvgColumnsIcons[type]?.icon || ""}
              <span>${sportsSvgColumnsIcons[type]?.title || ""}</span>
            </a>
            <a href="/collections/${type === "MLB" ? "baseball" : type}" class="search-result-sport-league">
              ${sportsSvgColumnsIcons[type]?.isTeamTag ? type : ""}
              ${sportsSvgColumnsIcons[type]?.isTeamTag ? '<span class="byteam-tag">By Team </span>' : ""}
            </a>
          `;

            types[type].forEach((result) => {
              if (!excludeTitlesProSport.includes(result.title)) {
                html += `
                <a href="${result.url}" class="search-result-item">
                  <div class="search-result-image-box">
                    <img src="${result.image}" alt="${result.title}">
                  </div>
                  <div class="search-result-title">${result.title}</div>
                </a>
              `;
              }
            });

            if (type === "NHL") {
              html += `<div class="extra-sports pt-4 flex flex-col">`;

              Object.keys(types).forEach((extraType) => {
                if (!mainTeamFilter.includes(extraType)) {
                  html += `
                  <div class="extra-sport-col col my-1">
                    <a href="/collections/${sportsSvgColumnsIcons[extraType]?.url}" class="search-result-columns-category">
                      ${sportsSvgColumnsIcons[extraType]?.icon || ""}
                      <span>${sportsSvgColumnsIcons[extraType]?.title || ""}</span>
                    </a>
                  </div>
                `;
                  types[extraType].forEach((result) => {
                    if (!excludeTitlesProSport.includes(result.title)) {
                      html += `
                      <a href="${result.url}" class="search-result-item">
                        <div class="search-result-image-box">
                          <img src="${result.image}" alt="${result.title}">
                        </div>
                        <div class="search-result-title">${result.title}</div>
                      </a>
                    `;
                    }
                  });
                }
              });

              html += `</div>`; // close extra-sports
            }

            html += `</div>`; // close colunm
          }
        });

        html += `</div>`; // close pro-teams-grid
        return html;
        break;

      case "NCAA":
        const excludeTitles = ["College Football", "College"];
        let htmlNCA = `<div class="college-teams-grid">`;
        Object.keys(types).forEach((type) => {
          if (types[type].length > 0) {
            htmlNCA += `<div class="college-teams-display">`;
            types[type].forEach((result) => {
              if (!excludeTitles.includes(result.title)) {
                htmlNCA += `
                <a href="${result.url}" class="search-result-item">
                  <div class="search-result-image-box">
                    <img src="${result.image}" alt="${result.title}">
                  </div>
                  <div class="search-result-title">${result.title}</div>
                </a>
              `;
              }
            });
            htmlNCA += `</div>`;
          }
        });

        htmlNCA += `</div>`;
        return htmlNCA;
        break;

      case "Mysterybox":
        // MysteryBoxesProducts
        const mysteryProducts = productsData.filter(
          (p) =>
            p.collection.toLowerCase().replace(/\s+/g, "") === "mysterybox",
        );
        mysteryProducts.sort(
          (a, b) => (b.available ? 1 : 0) - (a.available ? 1 : 0),
        );
        let htmlMBOX = `<div class="college-teams-grid">`;
        if (mysteryProducts.length > 0) {
          htmlMBOX += `<div class="college-teams-display">`;
          mysteryProducts.forEach((result) => {
            htmlMBOX += `
            <a href="${result.url}" class="search-result-item">
              <div class="search-result-image-box">
                <img src="${result.image}" alt="${result.title}">
                 ${!result.available ? `<div class="search-result-sold-out-badge">SOLD OUT</div>` : ""}
              </div>
              <div class="search-result-title">${result.title}</div>
            </a>
          `;
          });
          htmlMBOX += `</div>`;
        }
        htmlMBOX += `</div>`;
        return htmlMBOX;
        break;

      case "Entertainment":
        const { "TV & Film": tvAndFilm, Music: music } = types;
        let htmlEnt = `<div class="entertainment-container">`;
        htmlEnt += `<div class="entertainment-grid">
        <div class="tv-col col">
          <a href="/collections/tv-film" class="search-result-columns-category">
            <svg aria-hidden="true" data-prefix="fas" data-icon="tv" class="svg-inline--qicon qicon-tv qicon-w-20" role="img" xmlns="http://www.w3.org/2000/svg " viewBox="0 0 640 512"><path fill="currentColor" d="M592 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h245.1v32h-160c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160v-32H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h512v288z"></path></svg>
            <span>Tv & Filme</span>
          </a>`;

        (tvAndFilm || [])
          .map((result, index) => {
            htmlEnt += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlEnt += `</div>`;

        htmlEnt += `
        <div class="music-col col">
          <a href="/collections/music-1" class="search-result-columns-category">
            <svg aria-hidden="true" data-prefix="fas" data-icon="music" class="svg-inline--qicon qicon-music qicon-w-16" role="img" xmlns="http://www.w3.org/2000/svg " viewBox="0 0 512 512"><path fill="currentColor" d="M511.99 32.01c0-21.71-21.1-37.01-41.6-30.51L150.4 96c-13.3 4.2-22.4 16.5-22.4 30.5v261.42c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64V214.31l256-75.02v184.63c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64l-.01-351.99z"></path></svg>
            <span>Music</span>
          </a>`;

        (music || [])
          .map((result, index) => {
            htmlEnt += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlEnt += `</div>`;

        htmlEnt += `</div>`;
        htmlEnt += `</div>`;
        return htmlEnt;

      case "Patriotic":
        const { Military: militaryCollection, Patriotic: patrioticCollection } =
          types;
        let htmlPatr = `<div class="patriotic-container">`;
        htmlPatr += `<div class="patriotic-grid">
        <div class="military-col col">
          <a href="/collections/military" class="search-result-columns-category">
            <span>Military</span>
          </a>`;
        (militaryCollection || [])
          .map((result, index) => {
            htmlPatr += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlPatr += `</div>`;

        htmlPatr += `<div class="politic-col col">
        <a href="/collections/politics" class="search-result-columns-category">
          <span>Patriotic</span>
        </a>`;
        (patrioticCollection || [])
          .map((result, index) => {
            htmlPatr += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlPatr += `</div>`;
        htmlPatr += `</div>`;
        htmlPatr += `</div>`;
        return htmlPatr;

      case "Outdoors":
        const { "National Parks": nationalParksCollection } = types;
        let htmlOutdoor = `<div class="outdoor-container">`;
        htmlOutdoor += `<div class="outdoor-grid">
        <div class="head">
          <a href="/collections/national-parks" class="search-result-columns-category">
            <span>National Parks</span>
          </a>`;
        (nationalParksCollection || [])
          .map((result, index) => {
            htmlOutdoor += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlOutdoor += `</div>`;

        htmlOutdoor += ` </div>`;
        htmlOutdoor += `</div>`;
        return htmlOutdoor;

      case "Autographs":
        const { Autographs: autographsCollections } = types;
        let htmlAuth = `<div class="auth-container">`;
        htmlAuth += `<div class="auth-grid">`;
        (autographsCollections || [])
          .map((result, index) => {
            htmlAuth += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlAuth += `</div>`;
        htmlAuth += `</div>`;
        return htmlAuth;

      case "ByStyle":
        const {
          "Sports - SI Covers": siCollection,
          "Mid-Century": midCenturyCollection,
          Art: artCollection,
          Photography: photographyCollection,
          Spotlight: spotlightCollection,
          Vintage: vintageCollection,
        } = types;

        let htmlByStyle = `<div class="bystyle-container">`;
        htmlByStyle += `<div class="bystyle-grid">
        <div class="covers-col col">
          <a href="/collections/si-covers" class="search-result-columns-category">
            <span>Si Covers</span>
          </a>`;
        (siCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByStyle += `</div>`;

        htmlByStyle += `<div class="mid-col col">
        <a href="/collections/mid-century" class="search-result-columns-category">
          <span>Mid-Century</span>
        </a>`;
        (midCenturyCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByStyle += `</div>`;

        htmlByStyle += `  <div class="art-col col">
        <a href="/collections/art" class="search-result-columns-category">
          <span>Art</span>
        </a>`;
        (artCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByStyle += `</div>`;

        htmlByStyle += ` <div class="photo-col col">
        <a href="/collections/photography" class="search-result-columns-category">
          <span>Photography</span>
        </a>`;
        (photographyCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByStyle += `</div>`;

        htmlByStyle += ` <div class="spotlight-col col">
        <a href="/collections/spotlight" class="search-result-columns-category">
          <span>Spotlight</span>
        </a>`;
        (spotlightCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByStyle += `</div>`;

        htmlByStyle += ` <div class="timeline-col col" style="display:none;">
        <a href="/collections/timeline" class="search-result-columns-category">
          <span>Timeline</span>
        </a>`;

        htmlByStyle += `</div>`;

        htmlByStyle += `<div class="vintage-col col">
        <a href="/collections/vintage" class="search-result-columns-category">
          <span>Vintage</span>
        </a>`;
        (vintageCollection || [])
          .map((result, index) => {
            htmlByStyle += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlByStyle += `</div>`;

        htmlByStyle += `</div>`;
        htmlByStyle += `</div>`;
        return htmlByStyle;

      case "ByType":
        const {
          landscape: landscapeCollection,
          portrait: portraitCollection,
          Panorama: panoramaCollection,
          Coin: coinCollection,
        } = types;

        let htmlByType = `<div class="bytype-container">`;
        htmlByType += `<div class="bytype-grid">
        <div class="landscape-col col">
          <a href="/collections/landscape" class="search-result-columns-category">
            <span>Landscape</span>
          </a>`;
        (landscapeCollection || [])
          .map((result, index) => {
            htmlByType += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");

        htmlByType += `</div>`;

        htmlByType += ` <div class="portrait-col col">
        <a href="/collections/portrait" class="search-result-columns-category">
          <span>Portrait</span>
        </a>`;
        (portraitCollection || [])
          .map((result, index) => {
            htmlByType += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByType += `</div>`;

        htmlByType += ` <div class="panorama-col col">
        <a href="/collections/panorama" class="search-result-columns-category">
          <span>Panorama</span>
        </a>`;
        (panoramaCollection || [])
          .map((result, index) => {
            htmlByType += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByType += `</div>`;

        htmlByType += `<div class="coins-col col">
        <a href="/collections/coin" class="search-result-columns-category">
          <span>Coins</span>
        </a>`;
        (coinCollection || [])
          .map((result, index) => {
            htmlByType += `
          <a href="${result.url}" key="${index}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
          })
          .join("");
        htmlByType += `</div>`;

        htmlByType += `<div class="tradingcards-col col" style="display:none;">
        <a href="/collections/refractor" class="search-result-columns-category">
          <span>Trading Cards</span>
        </a>`;
        htmlByType += `</div>`;

        htmlByType += `</div>`;
        htmlByType += `</div>`;
        return htmlByType;

      case "Special":
        const {
          GOATS: goatsCollection,
          "Space and Tech": spaceCollection,
          eclipse: eclipseCollection,
        } = types;

        let htmlSpecial = `
        <div class="special-container">
          <div class="special-grid">
            <div class="goats-col col">
              <a href="/collections/goats" class="search-result-columns-category">
                <span>GOATS</span>
              </a>
              ${(goatsCollection || [])
                .map(
                  (result, index) => `
                <a href="${result.url}" key="${index}" class="search-result-item">
                  <div class="search-result-image-box">
                    <img src="${result.image}" alt="${result.title}">
                  </div>
                  <div class="search-result-title">${result.title}</div>
                </a>
              `,
                )
                .join("")}
            </div>

            <div class="spacetech-col col">
              <a href="/collections/space-and-tech" class="search-result-columns-category">
                <span>Space & Tech</span>
              </a>
              ${(spaceCollection || [])
                .map(
                  (result, index) => `
                <a href="${result.url}" key="${index}" class="search-result-item">
                  <div class="search-result-image-box">
                    <img src="${result.image}" alt="${result.title}">
                  </div>
                  <div class="search-result-title">${result.title}</div>
                </a>
              `,
                )
                .join("")}
            </div>

            <div class="eclipse-col col">
              <a href="/collections/eclipse" class="search-result-columns-category">
                <span>Eclipse</span>
              </a>
              ${(eclipseCollection || [])
                .map(
                  (result, index) => `
                <a href="${result.url}" key="${index}" class="search-result-item">
                  <div class="search-result-image-box">
                    <img src="${result.image}" alt="${result.title}">
                  </div>
                  <div class="search-result-title">${result.title}</div>
                </a>
              `,
                )
                .join("")}
            </div>
          </div>
        </div>
      `;
        return htmlSpecial;

      case "writtenSearch":
        let htmlTexted = `<div class="search-value-container">`;
        types.forEach((result) => {
          htmlTexted += `
          <a href="${result.url}" class="search-result-item">
            <div class="search-result-image-box">
              <img src="${result.image}" alt="${result.title}">
              ${!result.available ? `<div class="search-result-sold-out-badge">SOLD OUT</div>` : ""}
            </div>
            <div class="search-result-title">${result.title}</div>
          </a>`;
        });
        htmlTexted += `</div>`;
        return htmlTexted;

      case "NotFound":
        return `<div class="no-results" style="width:100%; height:100%;">
        <h1 style="color:black; text-align:center"> No results found </h1>
      </div>`;

      default:
        return `<div class="search-value-container"></div>`;
    }
  }

  function displayResults(results) {
    const types = {
      proSport: {
        NFL: [],
        NBA: [],
        MLB: [],
        NHL: [],
        "Sports - Golf": [],
        "Sports - Boxing": [],
        "Sports - Horse Racing": [],
        "Sports - Tennis": [],
        "Sports - Soccer": [],
        "Auto Racing": [],
        MMA: [],
      },
      NCAA: {
        NCAA: [],
      },
      Mysterybox: {
        MYSTERYBOX: [],
      },
      Entertainment: {
        "TV & Film": [],
        Music: [],
      },
      Patriotic: {
        Military: [],
        Patriotic: [],
      },
      Outdoors: {
        "National Parks": [],
      },
      Autographs: {
        Autographs: [],
      },
      ByStyle: {
        "Sports - SI Covers": [],
        "Mid-Century": [],
        Art: [],
        Photography: [],
        Spotlight: [],
        Vintage: [],
      },
      ByType: {
        landscape: [],
        portrait: [],
        Panorama: [],
        Coin: [],
      },
      Special: {
        GOATS: [],
        "Space and Tech": [],
        eclipse: [],
      },
      writtenSearch: results,
    };

    let isaddedCategory = false;
    const tagMap = new Map();
    Object.entries(types).forEach(([category, subcategories]) => {
      Object.keys(subcategories).forEach((tag) => {
        tagMap.set(tag, { category, subcategory: tag });
      });
    });

    results.forEach((result) => {
      result.collection?.rules?.forEach((rule) => {
        if (rule.column === "tag" && tagMap.has(rule.condition)) {
          const { category, subcategory } = tagMap.get(rule.condition);
          types[category][subcategory].push(result);
          isaddedCategory = true;
        }
      });
    });

    // console.log("types.writtenSearch", types.writtenSearch)

    let sidebarHtml = "";
    Object.keys(sideBarNavInfo).forEach((key) => {
      const item = sideBarNavInfo[key];
      sidebarHtml += `
      <button class="sidebar-button ${item.hasBorder ? "has-border" : ""} ${key === selectedSidebarKey ? "active" : ""} " data-section="${key}" >
        <div class="button-head">
        ${item.icon || ""}
        ${item.title || ""}
        </div>

        <div class="button-tail">
          ${item.arrowIcon || ""}
        </div>
        ${item?.isTeam ? '<span class="byteam-tag" >By Team </span>' : ""}
      </button>`;
    });

    //
    let html = `
        <div class="search-results-layout">
          <!--  SIDEBAR -->
          <div class="search-sidebar">
              ${sidebarHtml}
          </div>
          <!--  SIDEBAR -->
        ${renderComponentByKey(types[selectedSidebarKey], selectedSidebarKey)}
        </div>
      `;

    searchResults.innerHTML = html;

    document.querySelectorAll(".sidebar-button").forEach((button) => {
      if (window.innerWidth <= 500) {
        // Mobile → click
        button.addEventListener("click", function (e) {
          e.stopPropagation(); // evita fechar a caixa de resultados
          document
            .querySelectorAll(".sidebar-button")
            .forEach((btn) => btn.classList.remove("active"));
          e.currentTarget.classList.add("active");
          selectedSidebarKey = e.currentTarget.getAttribute("data-section");
          displayResults(results);
        });
      } else {
        // Desktop → hover
        button.addEventListener("mouseenter", function (e) {
          document
            .querySelectorAll(".sidebar-button")
            .forEach((btn) => btn.classList.remove("active"));
          e.currentTarget.classList.add("active");
          selectedSidebarKey = e.currentTarget.getAttribute("data-section");
          displayResults(results);
        });
      }
    });
  }

  // Display no results message
  function displayNoResults() {
    searchResults.innerHTML = `
        <div class="no-results" style="width:100%; height:100%" >
         <h1 style="color:black; text-align:center" > No results found </h2>
        </div>
      `;
  }

  function showLoading() {
    document.getElementById("loadingIndicator").style.display = "flex";
  }

  function hideLoading() {
    document.getElementById("loadingIndicator").style.display = "none";
  }
})();
